import React, { createContext, ReactNode, useContext } from 'react';

export type Redirects = {
  fromPath: string;
  isPermanent: boolean;
  ignoreCase: boolean;
  redirectInBrowser: boolean;
  toPath: string;
  statusCode: number;
}[];

const RedirectsContext = createContext<{ redirects: Redirects } | undefined>(
  undefined
);

export const RedirectsProvider = ({
  children,
  redirects,
}: {
  children: ReactNode;
  redirects: Redirects;
}) => {
  const value = React.useMemo(
    () => ({ redirects }),
    [JSON.stringify(redirects)]
  );

  return (
    <RedirectsContext.Provider value={value}>
      {children}
    </RedirectsContext.Provider>
  );
};

export const useRedirects = () => {
  const context = useContext(RedirectsContext);

  if (!context) {
    throw new Error('useRedirects must be used within a RedirectsProvider');
  }

  return context;
};
